'use client';

import Image from 'next/image';
import { usePartner } from '@/presentation/hooks/usePartner';

/**
 * PartnerBanner - Conditional banner for partner domains
 *
 * Only displays on partner-specific domains (mtn-test, telecel-test, etc.)
 * Hidden on generic marketplace (shop-staging.motito.co)
 *
 * Uses usePartner hook for hostname-based detection.
 */
export function PartnerBanner() {
  const { partner, isLoading, isPartnerDomain } = usePartner();

  // Don't show banner during loading to prevent flash
  if (isLoading) {
    return null;
  }

  // Only show banner on partner domains
  if (!isPartnerDomain || !partner.banner?.show) {
    return null;
  }

  return (
    <div className="hidden h-[80px] items-center justify-center gap-4 bg-motitoBlack text-sm text-white md:flex lg:text-base">
      <Image
        className="w-[60px]"
        width={100}
        height={60}
        src={partner.logo}
        alt={`${partner.title} logo`}
      />
      <p>{partner.banner.text}</p>
    </div>
  );
}

export default PartnerBanner;
